import { Button, Tooltip } from 'antd';
import React from 'react';
import { ReactComponent as LayoutIcon } from '../../../../../../resource/Layout.svg';
import { useDispatch } from 'react-redux';
import { requestsActions } from '../../../../requests.actions';

const Content = ({ record }) => {
  const dispatch = useDispatch();

  const onClick = (e) => {
    e.stopPropagation();

    dispatch(requestsActions.setShowModalChess({ record }));
  };

  return (
    <Tooltip title="Шахматка">
      <Button
        ghost
        shape="circle"
        style={{
          position: 'relative',
          top: '-0px',
          left: '-8px',
        }}
        onClick={onClick}
      >
        <LayoutIcon style={{ color: 'rgb(9, 149, 237)' }} />
      </Button>
    </Tooltip>
  );
};

export default Content;
